import _toConsumableArray from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import forIn from '@anm/helpers/object/forIn';
import isEqual from 'lodash/fp/isEqual';
var state = {
  head: []
};

var filterAlreadyAdded = function filterAlreadyAdded(sections) {
  return function (newElement) {
    return sections.filter(function (oldElement) {
      return !isEqual(oldElement, newElement);
    });
  };
};

var addToState = function addToState(element, sectionName) {
  var _element$props;

  var mappedElement = _objectSpread(_objectSpread({}, element), {}, {
    key: (_element$props = element.props) === null || _element$props === void 0 ? void 0 : _element$props.src
  });

  return state[sectionName] = [].concat(_toConsumableArray(filterAlreadyAdded(state[sectionName])(mappedElement)), [mappedElement]);
};

export var injectGlobal = forIn(addToState);
export var flushGlobal = function flushGlobal(sectionName) {
  var tags = state[sectionName];
  state[sectionName] = [];
  return tags;
};
export var getState = function getState() {
  return state;
};